import React from 'react';
import PropTypes from 'prop-types';

const SIZE_SMALL = 'small';

const IconDotsHorizontal = props => {
  const { className, size } = props;
  const sizes =
    size === SIZE_SMALL
      ? {
          width: '14',
          height: '14',
        }
      : {
          width: '24',
          height: '24',
        };

  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...sizes}
    >
      <path
        d="M4.5 13.75C5.4665 13.75 6.25 12.9665 6.25 12C6.25 11.0335 5.4665 10.25 4.5 10.25C3.5335 10.25 2.75 11.0335 2.75 12C2.75 12.9665 3.5335 13.75 4.5 13.75Z"
        fill="black"
      />
      <path
        d="M13.75 12C13.75 12.9665 12.9665 13.75 12 13.75C11.0335 13.75 10.25 12.9665 10.25 12C10.25 11.0335 11.0335 10.25 12 10.25C12.9665 10.25 13.75 11.0335 13.75 12Z"
        fill="black"
      />
      <path
        d="M21.25 12C21.25 12.9665 20.4665 13.75 19.5 13.75C18.5335 13.75 17.75 12.9665 17.75 12C17.75 11.0335 18.5335 10.25 19.5 10.25C20.4665 10.25 21.25 11.0335 21.25 12Z"
        fill="black"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconDotsHorizontal.defaultProps = {
  className: null,
};

IconDotsHorizontal.propTypes = {
  className: string,
};

export default IconDotsHorizontal;
